import React, { Component, Fragment } from 'react';
import { connect } from '@common/components/base.component';
import Address from '@common/components/addressGlobal/components/address.global.component';
import DDadosItem from '@common/components/ddados/ddados.item';
import dadosSolicitanteActions from '../store/dadosSolicitante.actions';
import dadosSolicitanteSelector from '../store/dadosSolicitante.selectors';
import { ddadosDadosSolicitante as DDados } from '../dadosSolicitante.ddados';
import { Row, Col } from 'react-bootstrap';
import autoBind from 'react-autobind';
import Panel from '@common/externos/components/panel/panel.component';

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      telObrigatorio: true,
      celObrigatorio: true,
    };
  }
  verificaTelefone() {
    const { dadosSolicitanteSelector } = this.props;
    const { dadosSolicitante } = dadosSolicitanteSelector;
    const { TelefoneSolicitante } = dadosSolicitante;
    const telefone = TelefoneSolicitante?.replace(/[^\d]+/g, '');
    if (telefone) {
      this.setState({ celObrigatorio: false, telObrigatorio: true });
    } else {
      this.setState({ celObrigatorio: true });
    }
  }
  verificaCelular() {
    const { dadosSolicitanteSelector } = this.props;
    const { dadosSolicitante } = dadosSolicitanteSelector;
    const { CelularSolicitante } = dadosSolicitante;
    const celular = CelularSolicitante?.replace(/[^\d]+/g, '');
    if (celular) {
      this.setState({ celObrigatorio: true, telObrigatorio: false });
    } else {
      this.setState({ telObrigatorio: true });
    }
  }

  handleCpfCnpjBlur(value) {
    var replaceMaskNew = value.replace(/[\._/-]/g, '').trim();
    var qtdCpfCnpjNew = replaceMaskNew.length;

    if (qtdCpfCnpjNew != 0) {
      this.props.dadosSolicitanteActions.getSolicitante(value);
    }
  }

  handleSolicitanteBlur = (value) => this.props.dadosSolicitanteActions.setSolicitante(value);

  render() {
    const { dadosSolicitanteSelector, prefix, disableAll } = this.props;
    const { Campos } = DDados;
    const { dadosSolicitante } = dadosSolicitanteSelector;
    const { celObrigatorio, telObrigatorio } = this.state;

    return (
      <Fragment>
        <Panel
          title={'Solicitante / Signatário / Responsável Legal'}
          defaultExpanded={false}
          Tooltip={
            'Preencha este grupo com os dados do responsável pela empresa ou com os dados de quem pode responder legalmente pela empresa perante a prefeitura.'
          }
        >
          <Row>
            <Col lg={3}>
              <DDadosItem
                name="CpfCnpjSolicitante"
                onBlur={this.handleCpfCnpjBlur}
                {...Campos.CpfCnpjSolicitante}
                state={dadosSolicitante}
                isView={disableAll}
              />
            </Col>
            <Col lg={6}>
              <DDadosItem
                name="NomeSolicitante"
                {...Campos.Nome}
                state={dadosSolicitante}
                isView={disableAll}
                onBlur={(value) => this.handleSolicitanteBlur({ NomeSolicitante: value })}
              />
            </Col>
            <Col lg={3}>
              <DDadosItem
                name="RgIeSolicitante"
                {...Campos.RgIe}
                state={dadosSolicitante}
                isView={disableAll}
                onBlur={(value) => this.handleSolicitanteBlur({ RgIeSolicitante: value })}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={3}>
              <DDadosItem
                name="TelefoneSolicitante"
                {...Campos.Telefone}
                state={dadosSolicitante}
                isView={disableAll}
                dynamicMask={'(99) 9999-9999'}
                onChange={(value) => {
                  this.handleSolicitanteBlur({ TelefoneSolicitante: value });
                  this.verificaTelefone();
                }}
                Obrigatorio={telObrigatorio}
              />
            </Col>
            <Col lg={3}>
              <DDadosItem
                name="CelularSolicitante"
                {...Campos.Celular}
                state={dadosSolicitante}
                isView={disableAll}
                dynamicMask={'(99) 99999-9999'}
                Obrigatorio={celObrigatorio}
                onChange={(value) => {
                  this.handleSolicitanteBlur({ CelularSolicitante: value });
                  this.verificaCelular();
                }}
              />
            </Col>
            <Col lg={6}>
              <DDadosItem
                name="EmailSolicitante"
                {...Campos.Email}
                state={dadosSolicitante}
                isView={disableAll}
                onBlur={(value) => this.handleSolicitanteBlur({ EmailSolicitante: value })}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Address
                name="EnderecoSolicitante"
                state={dadosSolicitante.EnderecoSolicitante}
                prefix={prefix}
                onBlur={(values) => this.props.dadosSolicitanteActions.setEnderecoSolicitante(values)}
              />
            </Col>
          </Row>
        </Panel>
      </Fragment>
    );
  }
}

export default connect({
  actions: {
    dadosSolicitanteActions,
  },
  selectors: {
    dadosSolicitanteSelector,
  },
})(Container);
